import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/custom-font.css'
import VueLazyload from 'vue-lazyload';
const app= createApp(App);
app.use(router);
// 注册 VueLazyload 插件
app.use(VueLazyload);
app.mount('#app');
app.config.productionTip = false;
export default {
    css: {
        loaderOptions: {
            postcss: {
                postcssOptions: {
                    path: 'postcss.config.js',
                },
            },
        },
    },
};
